import { SideNavLink, ToolbarItem } from '@amzn/aac-chrome-internal-api';

/**
 * The first link of the item's first sidebar group, or undefined when the item
 * has no groups or its first group has no links. The nav payload does not
 * guarantee either, so callers render nothing rather than throw on a malformed
 * item.
 */
export const getFirstSideNavLink = (
  toolbarItem: Pick<ToolbarItem, 'sidebarGroups'>,
): SideNavLink | undefined => toolbarItem.sidebarGroups[0]?.links[0];

/**
 * The item's only link when it is a "single app": exactly one sidebar group
 * holding exactly one link. Undefined for anything else, including an item
 * with no groups.
 */
export const getSingleAppLink = (
  toolbarItem: Pick<ToolbarItem, 'sidebarGroups'>,
): SideNavLink | undefined => {
  const [onlyGroup, ...otherGroups] = toolbarItem.sidebarGroups;
  if (!onlyGroup || otherGroups.length > 0) {
    return undefined;
  }
  const [onlyLink, ...otherLinks] = onlyGroup.links;
  return otherLinks.length === 0 ? onlyLink : undefined;
};
